import React from 'react';
import './style.css'

const Footer = () => {
    return(
        <div id="contact" className="footer-area">
            <div className="container">
                <div className="footer-content">
                    <div className="content-sub">
                        <h2>Σας ευχαριστούμε πολύ</h2>
                        <div className="footer-info">
                        <span> Για περαιτέρω πληροφορίες καλέστε:</span>
                        <span>Θεοχάρης: 6986177818</span>
                        <span>Αντριανή: 6992871976</span>
                        </div>
                    </div>

                    <div className="footer-copyrights">
                        <p>Website developed by <a href="https://gr.linkedin.com/in/stavros-kosmas-lazaris-0a080b160" target="_blank" rel="noreferrer"> S.Lazaris </a>    
                            © 2025. 
                            <br/>
                            All Rights Reserved</p>
                        </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;